import { ChecklistStatusIndicator } from '@/types/status-indicators.type';
import { create } from 'zustand';

interface CustomStatusIndicatorsState {
  // For runtime (run) UI
  customStatusIndicators: ChecklistStatusIndicator[] | undefined;
  setCustomStatusIndicators: (
    customStatusIndicators: ChecklistStatusIndicator[]
  ) => void;

  // For builder‐preview UI
  builderCustomStatusIndicators: ChecklistStatusIndicator[] | undefined;
  setBuilderCustomStatusIndicators: (
    builderCustomStatusIndicators: ChecklistStatusIndicator[]
  ) => void;

  // Reset both back to undefined
  reset: () => void;
}

export const useCustomStatusIndicatorsStore =
  create<CustomStatusIndicatorsState>(set => ({
    customStatusIndicators: undefined,
    setCustomStatusIndicators: customStatusIndicators => {
      set({ customStatusIndicators });
    },

    builderCustomStatusIndicators: undefined,
    setBuilderCustomStatusIndicators: builderCustomStatusIndicators => {
      set({ builderCustomStatusIndicators });
    },

    reset: () => {
      set({
        customStatusIndicators: undefined,
        builderCustomStatusIndicators: undefined
      });
    }
  }));
